import {
    QueryClient,
    QueryKey,
    UseQueryOptions,
    UseQueryResult,
    useQuery,
    UseMutationOptions,
    useMutation,
    UseMutationResult,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

// TODO: Still not sure if it is a good idea to return ApiResponse<TQueryFnData> or just TQueryFnData
// export const useQueryApi = <
//     TQueryFnData = unknown,
//     TData = TQueryFnData,
//     TError = AxiosError<ApiResponse<{ error: string }>>,
//     TQueryKey extends QueryKey = QueryKey,
// >(
//     options: UseQueryOptions<ApiResponse<TQueryFnData>, TError, TData, TQueryKey>,
//     queryClient?: QueryClient
// ): UseQueryResult<ApiResponse<TQueryFnData>, TError> => {
//     return useQuery<ApiResponse<TQueryFnData>, TError, TData, TQueryKey>(options, queryClient);
// };
export const useQueryApi = <
    TQueryFnData = unknown,
    TError = AxiosError<ApiErrorResponse>,
    TData = TQueryFnData,
    TQueryKey extends QueryKey = QueryKey,
>(
    options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
    queryClient?: QueryClient
): UseQueryResult<TData, TError> => {
    return useQuery<TQueryFnData, TError, TData, TQueryKey>(
        {
            ...options,
            retry: 0,
        },
        queryClient
    );
};

// TODO: Still not sure if it is a good idea to return ApiResponse<TQueryFnData> or just TQueryFnData
// export const useMutationApi = <
//     TResponse = unknown,
//     TVariables = unknown, // Swapped TVariables with TError because TError is specific for ours
//     TError = AxiosError<ApiResponse<{ error: string }>>,
//     TContext = unknown,
// >(
//     options: UseMutationOptions<ApiResponse<TResponse>, TError, TVariables, TContext>,
//     queryClient?: QueryClient
// ): UseMutationResult<ApiResponse<TResponse>, TError, TVariables, TContext> => {
//     return useMutation<ApiResponse<TResponse>, TError, TVariables, TContext>(options, queryClient);
// };

export const useMutationApi = <
    TResponse = unknown,
    TVariables = unknown, // Swapped TVariables with TError because TError is specific for ours
    TError = AxiosError<ApiErrorResponse>,
    TContext = unknown,
>(
    options: UseMutationOptions<TResponse, TError, TVariables, TContext>,
    queryClient?: QueryClient
): UseMutationResult<TResponse, TError, TVariables, TContext> => {
    return useMutation<TResponse, TError, TVariables, TContext>(options, queryClient);
};
